/**
 * Hindi display names for the panchang engine's tithi and paksha values. Lives
 * in lib/ so both the /tithi-today route and the shared panchang components
 * can use it (components may not import route modules).
 */
const TITHI_NAMES_HI: Readonly<Record<string, string>> = {
  Pratipada: "प्रतिपदा",
  Dwitiya: "द्वितीया",
  Tritiya: "तृतीया",
  Chaturthi: "चतुर्थी",
  Panchami: "पंचमी",
  Shashthi: "षष्ठी",
  Shashti: "षष्ठी",
  Saptami: "सप्तमी",
  Ashtami: "अष्टमी",
  Navami: "नवमी",
  Dashami: "दशमी",
  Ekadashi: "एकादशी",
  Dwadashi: "द्वादशी",
  Trayodashi: "त्रयोदशी",
  Chaturdashi: "चतुर्दशी",
  Purnima: "पूर्णिमा",
  Amavasya: "अमावस्या",
};

export function displayTithiName(name: string, language: "en" | "hi"): string {
  return language === "hi" ? (TITHI_NAMES_HI[name] ?? name) : name;
}

export function displayPakshaName(paksha: string, language: "en" | "hi"): string {
  if (language === "en") return paksha;
  const normalized = paksha.toLowerCase();
  if (normalized.includes("shukla")) return "शुक्ल पक्ष";
  if (normalized.includes("krishna")) return "कृष्ण पक्ष";
  return paksha;
}
